module.exports = __webpack_public_path__ + "static/media/book.b40767c7.svg";